/**
 * Typ akce frame.
 *
 * @ignore
 */
export enum FrameActionEnum {
    /**
     * Nastavení pozastavení odebírání z fronty zpráv.
     */
    SET_POST_SUSPENDED = 'frame.setPostSuspended',

    /**
     * Odebrání zprávy z fronty.
     */
    POST_MESSAGE = 'frame.postMessage',

    /**
     * Smazání fronty zpráv.
     */
    CLEAR_MESSAGES = 'frame.clearMessages',
}

export type PostSuspendedAction = {type: FrameActionEnum.SET_POST_SUSPENDED; suspended: boolean};
export type PostMessageAction<T> = {type: FrameActionEnum.POST_MESSAGE; message: T};
export type ClearMessagesAction = {type: FrameActionEnum.CLEAR_MESSAGES};
export type FrameAction = PostSuspendedAction | PostMessageAction<any> | ClearMessagesAction;
